import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Link,
  withRouter,
} from 'react-router-dom';
import { useIntl } from 'react-intl';

const AdminBreadcrumbs = ({ match }) => {
  const intl = useIntl();

  const adminUrls = [
    {
      url: '/collectiongroups',
      param: 'collectionGroupId',
      label: intl.formatMessage({ defaultMessage: 'Collection groups' }),
    },
    {
      url: '/collectiongroups/add',
      targetUrl: '/collectiongroups',
      label: intl.formatMessage({ defaultMessage: 'Collection groups' }),
    },
    {
      url: '/teams',
      param: 'groupId',
      label: intl.formatMessage({ defaultMessage: 'Teams' }),
    },
    {
      url: '/teams/add',
      targetUrl: '/teams',
      label: intl.formatMessage({ defaultMessage: 'Teams' }),
    },
    {
      url: '/pages',
      param: 'pageId',
      label: intl.formatMessage({ defaultMessage: 'Content Portals' }),
    },
    {
      url: '/pages/add',
      targetUrl: '/pages',
      label: intl.formatMessage({ defaultMessage: 'Content Portals' }),
    },
    {
      url: '/roles',
      param: 'roleId',
      label: intl.formatMessage({ defaultMessage: 'Roles' }),
    },
    {
      url: '/roles/add',
      targetUrl: '/roles',
      label: intl.formatMessage({ defaultMessage: 'Roles' }),
    },
    {
      url: '/categories',
      param: 'taxonomyId',
      label: intl.formatMessage({ defaultMessage: 'Tag Categories' }),
    },
    {
      url: '/categories/add',
      targetUrl: '/categories',
      label: intl.formatMessage({ defaultMessage: 'Tag Categories' }),
    },
    {
      url: '/users',
      param: 'userUuid',
      label: intl.formatMessage({ defaultMessage: 'Users' }),
    },
    {
      url: '/users/add',
      targetUrl: '/users',
      label: intl.formatMessage({ defaultMessage: 'Users' }),
    },
    {
      url: '/reports',
      param: 'reportId',
      label: intl.formatMessage({ defaultMessage: 'Reports' }),
    },
    {
      url: '/upload-pages',
      param: 'uploadPageUuid',
      label: intl.formatMessage({ defaultMessage: 'Guest upload pages' }),
    },
  ];

  const { url, params } = match;

  const getBreadcrumbs = () => {
    const breadcrumbs = [];

    adminUrls.forEach((adminUrl) => {
      if (url.indexOf(`/admin${adminUrl.url}`) === 0) {
        if (adminUrl.param) {
          if (params[adminUrl.param]) {
            breadcrumbs.push(adminUrl);
          }
        } else {
          breadcrumbs.push({
            url: adminUrl.targetUrl,
            label: adminUrl.label,
          });
        }
      }
    });

    return breadcrumbs;
  };

  return (
    <div className="breadcrumbs">
      <Link to="/admin/settings">
        {intl.formatMessage({ defaultMessage: 'Settings' })}
      </Link>
      <span>/</span>
      {getBreadcrumbs().map(b => (
        <Fragment key={b.url}>
          <Link to={`/admin${b.url}`}>
            {b.label}
          </Link>
          <span>/</span>
        </Fragment>
      ))}
    </div>
  );
};

AdminBreadcrumbs.propTypes = {
  match: PropTypes.object.isRequired,
};

export default withRouter(AdminBreadcrumbs);
